import {FigmaDesignSnapshot} from './figma-chat-design.model';

export type FigmaStylingMode = 'standard' | 'experimental';

export interface FigmaProductCardDraft {
  mode: FigmaStylingMode;
  designUrl: string;
  selectedNodeId: string;
  revision: string;
}

export interface FigmaProductCardMapping {
  sourcePath: string;
  targetPath: string;
}

export interface FigmaStandardSetting {
  path: string;
  valueType: string;
  canMap: boolean;
}

export interface FigmaProductCardMaster {
  masterTemplateUrl: string;
  mappings: FigmaProductCardMapping[];
  revision: string;
  standardSettings: FigmaStandardSetting[];
}

export interface FigmaProductCardEditor {
  draft: FigmaProductCardDraft;
  canManageMaster: boolean;
  master?: FigmaProductCardMaster;
  importStatus: 'not-connected' | 'connected';
  snapshot?: FigmaDesignSnapshot | null;
  canRefresh?: boolean;
  localRuntimeEnabled?: boolean;
}

export interface RefreshFigmaDesignResponse { draft: FigmaProductCardDraft; snapshot: FigmaDesignSnapshot; }

export function isFigmaPageUrl(value: string): boolean {
  return isFigmaUrl(value, true);
}

export function isFigmaFileUrl(value: string): boolean {
  return isFigmaUrl(value, false);
}

function isFigmaUrl(value: string, requireNode: boolean): boolean {
  if (value === '') return true;
  if (value.length > 2048 || /[\s\p{Cc}]/u.test(value)) return false;
  try {
    const url = new URL(value);
    const nodes = url.searchParams.getAll('node-id');
    return url.protocol === 'https:' && ['figma.com', 'www.figma.com'].includes(url.hostname)
      && !url.port && !url.username && !url.password && !url.hash
      && /^\/(design|file)\/[A-Za-z0-9]+(?:\/[^/]+)?\/?$/.test(url.pathname)
      && ((!requireNode && nodes.length === 0)
        || (nodes.length === 1 && /^[0-9]{1,10}[-:][0-9]{1,10}$/.test(nodes[0])));
  } catch {
    return false;
  }
}
